import type { Scan } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import { initialScanProgress, type ScanProgress } from "../../core/primitives/scan-progress";

/** Upload (1), scanning (2), review (3), done (5). Step 4 was the old save step and the numbering is kept. */
export type ScanStep = 1 | 2 | 3 | 5;

/** Snapshot of the confirmed card, shown on the Done step. */
export type ConfirmedCard = { cardId: string; title: string; priceCents: number | null; stocked: boolean };

export class ScanCardState {
  /** The shell guarantees a shop, but the selection can still change. */
  readonly noMatch = new Rx<Scan | null>(null);
  readonly hasStore = new Rx(true);
  readonly step = new Rx<ScanStep>(1);
  /** On a phone the upload step is two photos in turn. */
  readonly mobileSubstep = new Rx<1 | 2>(1);
  readonly frontPreview = new Rx<string | null>(null);
  readonly backPreview = new Rx<string | null>(null);
  readonly scanProgress = new Rx<ScanProgress>(initialScanProgress());
  readonly scanError = new Rx<string | null>(null);
  readonly confirmed = new Rx<ConfirmedCard | null>(null);
  /** Reopening the scan the URL names, after a refresh. */
  readonly restoring = new Rx(false);

  /** Set when staff scan on a counter (POS) customer's behalf: the scan is theirs. */
  constructor(readonly customerId: string | null = null) {}
}

export abstract class ScanCardActions {
  abstract setFront(file: File): void;
  abstract setBack(file: File): void;
  abstract toBackStep(): void;
  abstract scan(skipBack?: boolean): Promise<void>;
  abstract cancelScan(): void;
  abstract newScan(): void;
}
